export const environment = {
  production: false,
  themeAppRoot: false,
  baseUrl: 'https://api-qa.aspose.ai/imaging/common/api',
  acceptFormats:
    '.jpg,.jpeg,.j2k,.bmp,.tif,.tiff,.tga,.webp,.cdr,.cmx,.dicom,.dcm,.djvu,.dng,.emf,.gif,.odg,.otg,.png,.svg,.wmf',
};
